module.exports = __webpack_public_path__ + "static/media/file-icon-gray.bb9f23d4.svg";